@if (hasAppointments) {
  <div class="w-full bg-gray-700 bg-opacity-80 p-1 rounded-t relative z-20">
    <div class="flex space-x-2 overflow-x-auto" [class.hidden]="isMinimised$()">
      @for (appt of service.appts$(); track appt) {
        <div
          [class.hover:bg-opacity-80]="appt.appointment.appointmentType === AppointmentType.Video || appt.appointment.appointmentType === AppointmentType.Audio"
          class="flex items-center bg-gray-800 text-white text-sm rounded-full p-1 space-x-2 cursor-pointer transition"
          (click)="joinAppointment(appt)">
          <!-- Join button -->
          <button
            aria-label="Join"
            class="flex-none p-2 bg-blue-850 rounded-full">
            <app-icon icon="{{ getAppointmentTypeIcon(appt.appointment.appointmentType) }}" fontSize="22px" lineHeight="22px"></app-icon>
          </button>
          <!-- Title + time -->
          <div class="flex-1 min-w-0">
            <div class="font-medium truncate">{{ appt.appointment.title }}</div>
            <div class="flex text-xs items-center text-gray-300">
              <app-icon icon="mdi-clock-outline" lineHeight="14px" fontSize="14px"></app-icon>
              <span>{{ appt.appointment.startTime | localizedDate:'HH:mm aa' }}</span>
            </div>
          </div>
          <!-- Participant avatars -->
          <div class="flex -space-x-1 flex-none">
            @for (part of appt.participants; track part) {
              @if (part.userId !== authUserId) {
                <div
                  class="w-8 h-8 bg-gray-950 rounded-full flex items-center justify-center text-xs"
                  [tooltip]="part.firstName + ' ' + part.lastName"
                containerClass="fitmed-tooltip">{{ getInitials(part) }}</div>
              }
            }
          </div>
        </div>
      }
    </div>
    <div class="absolute right-2 top-[-35px]">
      @if (isMinimised$()) {
        <div class="bg-blue-850 cursor-pointer px-3 py-1 rounded" (click)="isMinimised$.set(false)">
          <app-icon icon="mdi-arrow-collapse-up"></app-icon>
        </div>
      }
      @if (!isMinimised$()) {
        <div class="bg-blue-850 cursor-pointer px-3 py-1 rounded" (click)="isMinimised$.set(true)">
          <app-icon icon="mdi-arrow-collapse-down"></app-icon>
        </div>
      }
    </div>
  </div>
}
